import {Message} from "@arco-design/web-react";

export const copy = (event, selector) => {
    const target = selector ? document.querySelector(selector) : event.target;
    target.select();
    const value = target.value;
    if (!value) {
        return;
    }
    if (navigator.clipboard) {
        const clipboard = navigator.clipboard;
        clipboard.writeText(value);
    } else {
        document.execCommand("copy");
    }
    Message.success("复制成功");
}
